import { Outlet, ScrollRestoration } from 'react-router-dom';
import Navigation from './components/navigation';
import Footer from './components/footer';

function App() {
  return (
    <div className="site">
      <Navigation />
      <main className="site-main">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}

export default App;
